// // client/src/pages/payment/PaymentRecordsPage.jsx

// import React, {
//   useCallback,
//   useEffect,
//   useRef,
//   useState,
// } from "react";

// import {
//   searchInvoices,
//   getQuarters,
//   updateInvoice,
// } from "../../api/paymentApi";

// import PaymentEditModal from "../../components/payment/PaymentEditModal";

// // ─────────────────────────────────────
// // CONSTANTS
// // ─────────────────────────────────────
// const VENDORS = [
//   "AIRTEL",
//   "ANONET",
//   "MICROSCAN",
//   "TATA_COMMUNICATIONS",
//   "SIFY",
//   "SYMPHONY",
//   "NTT_GLOBAL",
//   "NTT",
//   "TATA",
//   "TIKONA",
//   "XTELIFY",
// ];

// const INITIAL_FILTERS = {
//   invoice_number: "",
//   vendor: "",
//   billing_quarter: "",
//   payment_status: "",
// };

// // ─────────────────────────────────────
// // COMPONENT
// // ─────────────────────────────────────
// export default function PaymentRecordsPage() {

//   // ─────────────────────────────────────
//   // STATE
//   // ─────────────────────────────────────
//   const [filters, setFilters] = useState(INITIAL_FILTERS);

//   const [invoices, setInvoices] = useState([]);

//   const [quarters, setQuarters] = useState([]);

//   const [loading, setLoading] = useState(false);

//   const [selectedInvoice, setSelectedInvoice] = useState(null);

//   const [showEditModal, setShowEditModal] = useState(false);

//   const [saveLoading, setSaveLoading] = useState(false);

//   const debounceRef = useRef(null);

//   // ─────────────────────────────────────
//   // LOAD QUARTERS ON MOUNT
//   // ─────────────────────────────────────
//   useEffect(() => {

//     const loadQuarters = async () => {

//       try {

//         const data = await getQuarters();

//         setQuarters(data.quarters || []);

//       } catch (error) {

//         console.error("Failed to load quarters:", error);
//       }
//     };

//     loadQuarters();

//   }, []);

//   // ─────────────────────────────────────
//   // FETCH INVOICES
//   // ─────────────────────────────────────
//   const fetchInvoices = useCallback(async (currentFilters) => {

//     try {

//       setLoading(true);

//       const data = await searchInvoices(currentFilters);

//       setInvoices(data.invoices || []);

//     } catch (error) {

//       console.error("Search failed:", error);

//     } finally {

//       setLoading(false);
//     }

//   }, []);

//   // ─────────────────────────────────────
//   // DEBOUNCED SEARCH
//   // ─────────────────────────────────────
//   useEffect(() => {

//     if (debounceRef.current) {
//       clearTimeout(debounceRef.current);
//     }

//     debounceRef.current = setTimeout(() => {
//       fetchInvoices(filters);
//     }, 300);

//     return () => {
//       if (debounceRef.current) {
//         clearTimeout(debounceRef.current);
//       }
//     };

//   }, [filters, fetchInvoices]);

//   // ─────────────────────────────────────
//   // FILTER CHANGE
//   // ─────────────────────────────────────
//   const handleFilterChange = (key, value) => {

//     setFilters((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };

//   // ─────────────────────────────────────
//   // OPEN EDIT MODAL
//   // ─────────────────────────────────────
//   const handleEdit = (invoice) => {

//     setSelectedInvoice(invoice);

//     setShowEditModal(true);
//   };

//   // ─────────────────────────────────────
//   // CLOSE MODAL
//   // ─────────────────────────────────────
//   const handleCloseModal = () => {

//     setShowEditModal(false);

//     setSelectedInvoice(null);
//   };

//   // ─────────────────────────────────────
//   // SAVE INVOICE
//   // ─────────────────────────────────────
//   const handleSaveInvoice = async (updatedData) => {

//     try {

//       setSaveLoading(true);

//       await updateInvoice(selectedInvoice._id, updatedData);

//       await fetchInvoices(filters);

//       handleCloseModal();

//     } catch (error) {

//       console.error("Update Error:", error);

//       alert("Failed to update invoice");

//     } finally {

//       setSaveLoading(false);
//     }
//   };

//   // ─────────────────────────────────────
//   // RENDER
//   // ─────────────────────────────────────
//   return (

//     <div className="page-wrap">

//       {/* HEADER */}

//       <header className="topbar">

//         <div className="brand">

//           <span className="logo">🗂️</span>

//           <div>

//             <div className="title">Payment Records</div>

//             <div className="subtitle">Search and manage invoice records</div>

//           </div>

//         </div>

//       </header>

//       {/* MAIN */}

//       <main
//         style={{
//           paddingTop: "80px",
//           paddingBottom: "60px",
//           paddingLeft: "32px",
//           paddingRight: "32px",
//           maxWidth: "1400px",
//           margin: "0 auto",
//         }}
//       >

//         {/* FILTER BAR */}

//         <div style={styles.filterBar}>

//           {/* INVOICE NUMBER */}

//           <div style={styles.filterItem}>
//             <label style={styles.filterLabel}>Invoice Number</label>
//             <input
//               type="text"
//               placeholder="Search invoice..."
//               value={filters.invoice_number}
//               onChange={(e) =>
//                 handleFilterChange("invoice_number", e.target.value)
//               }
//               style={styles.filterInput}
//             />
//           </div>

//           {/* VENDOR */}

//           <div style={styles.filterItem}>
//             <label style={styles.filterLabel}>Vendor</label>
//             <select
//               value={filters.vendor}
//               onChange={(e) =>
//                 handleFilterChange("vendor", e.target.value)
//               }
//               style={styles.filterSelect}
//             >
//               <option value="">All Vendors</option>
//               {VENDORS.map((v) => (
//                 <option key={v} value={v}>
//                   {v}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* QUARTER */}

//           <div style={styles.filterItem}>
//             <label style={styles.filterLabel}>Quarter</label>
//             <select
//               value={filters.billing_quarter}
//               onChange={(e) =>
//                 handleFilterChange("billing_quarter", e.target.value)
//               }
//               style={styles.filterSelect}
//             >
//               <option value="">All Quarters</option>
//               {quarters.map((q) => (
//                 <option key={q} value={q}>
//                   {q}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* STATUS */}

//           <div style={styles.filterItem}>
//             <label style={styles.filterLabel}>Payment Status</label>
//             <select
//               value={filters.payment_status}
//               onChange={(e) =>
//                 handleFilterChange("payment_status", e.target.value)
//               }
//               style={styles.filterSelect}
//             >
//               <option value="">All</option>
//               <option value="PAID">PAID</option>
//               <option value="UNPAID">UNPAID</option>
//             </select>
//           </div>

//         </div>

//         {/* RESULTS META */}

//         <div style={styles.resultsMeta}>

//           {loading ? (

//             <span style={styles.loadingText}>Searching...</span>

//           ) : (

//             <span style={styles.resultsCount}>
//               {invoices.length} record{invoices.length !== 1 ? "s" : ""} found
//             </span>
//           )}

//         </div>

//         {/* TABLE WRAPPER */}

//         <div style={styles.tableWrapper}>

//           <table style={styles.table}>

//             {/* THEAD */}

//             <thead>
//               <tr>
//                 {[
//                   "Invoice Number",
//                   "Vendor",
//                   "Service Period",
//                   "Billing Quarter",
//                   "Payment Status",
//                   "Payment Date",
//                   "Reference Number",
//                   "Actions",
//                 ].map((col) => (
//                   <th key={col} style={styles.th}>
//                     {col}
//                   </th>
//                 ))}
//               </tr>
//             </thead>

//             {/* TBODY */}

//             <tbody>

//               {!loading && invoices.length === 0 && (

//                 <tr>
//                   <td colSpan={8} style={styles.emptyCell}>
//                     No records found. Adjust your filters.
//                   </td>
//                 </tr>
//               )}

//               {invoices.map((invoice, index) => (

//                 <tr
//                   key={invoice._id}
//                   style={{
//                     ...styles.tr,
//                     backgroundColor:
//                       index % 2 === 0 ? "#ffffff" : "#f9fafb",
//                   }}
//                 >

//                   <td style={styles.td}>
//                     <span style={styles.invoiceNumber}>
//                       {invoice.invoice_number || "—"}
//                     </span>
//                   </td>

//                   <td style={styles.td}>
//                     <span style={styles.vendorBadge}>
//                       {invoice.vendor || "—"}
//                     </span>
//                   </td>

//                   <td style={styles.td}>
//                     {invoice.service_period || "—"}
//                   </td>

//                   <td style={styles.td}>
//                     <span style={styles.quarterBadge}>
//                       {invoice.billing_quarter || "—"}
//                     </span>
//                   </td>

//                   <td style={styles.td}>
//                     <span
//                       style={{
//                         ...styles.statusBadge,
//                         ...(invoice.payment_status === "PAID"
//                           ? styles.statusPaid
//                           : styles.statusUnpaid),
//                       }}
//                     >
//                       {invoice.payment_status || "—"}
//                     </span>
//                   </td>

//                   <td style={styles.td}>
//                     {invoice.payment_date
//                       ? new Date(invoice.payment_date).toLocaleDateString(
//                           "en-IN"
//                         )
//                       : "—"}
//                   </td>

//                   <td style={styles.td}>
//                     {invoice.payment_reference_number || "—"}
//                   </td>

//                   <td style={styles.td}>
//                     <button
//                       onClick={() => handleEdit(invoice)}
//                       style={styles.editButton}
//                       title="Edit Invoice"
//                     >
//                       ✏️
//                     </button>
//                   </td>

//                 </tr>
//               ))}

//             </tbody>

//           </table>

//         </div>

//       </main>

//       {/* MODAL */}

//       {showEditModal && (

//         <PaymentEditModal
//           invoice={selectedInvoice}
//           onClose={handleCloseModal}
//           onSave={handleSaveInvoice}
//           loading={saveLoading}
//         />
//       )}

//     </div>
//   );
// }

// // ─────────────────────────────────────
// // STYLES
// // ─────────────────────────────────────
// const styles = {

//   filterBar: {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "16px",
//     alignItems: "flex-end",
//     padding: "20px 24px",
//     backgroundColor: "#ffffff",
//     border: "1px solid #e5e7eb",
//     borderRadius: "10px",
//     marginBottom: "16px",
//   },

//   filterItem: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "6px",
//     minWidth: "180px",
//     flex: "1",
//   },

//   filterLabel: {
//     fontSize: "11px",
//     fontWeight: "600",
//     color: "#6b7280",
//     textTransform: "uppercase",
//     letterSpacing: "0.05em",
//   },

//   filterInput: {
//     height: "36px",
//     padding: "0 12px",
//     fontSize: "13px",
//     color: "#111827",
//     backgroundColor: "#f9fafb",
//     border: "1px solid #e5e7eb",
//     borderRadius: "6px",
//     outline: "none",
//     transition: "border-color 0.15s",
//   },

//   filterSelect: {
//     height: "36px",
//     padding: "0 12px",
//     fontSize: "13px",
//     color: "#111827",
//     backgroundColor: "#f9fafb",
//     border: "1px solid #e5e7eb",
//     borderRadius: "6px",
//     outline: "none",
//     cursor: "pointer",
//   },

//   resultsMeta: {
//     display: "flex",
//     alignItems: "center",
//     marginBottom: "10px",
//     paddingLeft: "2px",
//   },

//   resultsCount: {
//     fontSize: "13px",
//     color: "#6b7280",
//     fontWeight: "500",
//   },

//   loadingText: {
//     fontSize: "13px",
//     color: "#9ca3af",
//     fontStyle: "italic",
//   },

//   tableWrapper: {
//     width: "100%",
//     overflowX: "auto",
//     overflowY: "auto",
//     maxHeight: "calc(100vh - 280px)",
//     border: "1px solid #e5e7eb",
//     borderRadius: "10px",
//     backgroundColor: "#ffffff",
//   },

//   table: {
//     width: "100%",
//     borderCollapse: "collapse",
//     fontSize: "13px",
//     tableLayout: "auto",
//   },

//   th: {
//     position: "sticky",
//     top: 0,
//     backgroundColor: "#f3f4f6",
//     color: "#374151",
//     fontWeight: "600",
//     fontSize: "11px",
//     textTransform: "uppercase",
//     letterSpacing: "0.05em",
//     padding: "11px 16px",
//     textAlign: "left",
//     borderBottom: "1px solid #e5e7eb",
//     whiteSpace: "nowrap",
//     zIndex: 1,
//   },

//   tr: {
//     transition: "background-color 0.1s",
//   },

//   td: {
//     padding: "11px 16px",
//     color: "#374151",
//     borderBottom: "1px solid #f3f4f6",
//     whiteSpace: "nowrap",
//     verticalAlign: "middle",
//   },

//   emptyCell: {
//     padding: "48px 16px",
//     textAlign: "center",
//     color: "#9ca3af",
//     fontSize: "14px",
//   },

//   invoiceNumber: {
//     fontFamily: "monospace",
//     fontSize: "12px",
//     color: "#1d4ed8",
//     fontWeight: "600",
//   },

//   vendorBadge: {
//     display: "inline-block",
//     padding: "2px 8px",
//     backgroundColor: "#eff6ff",
//     color: "#1d4ed8",
//     borderRadius: "4px",
//     fontSize: "11px",
//     fontWeight: "600",
//   },

//   quarterBadge: {
//     display: "inline-block",
//     padding: "2px 8px",
//     backgroundColor: "#f5f3ff",
//     color: "#7c3aed",
//     borderRadius: "4px",
//     fontSize: "11px",
//     fontWeight: "600",
//   },

//   statusBadge: {
//     display: "inline-block",
//     padding: "2px 10px",
//     borderRadius: "20px",
//     fontSize: "11px",
//     fontWeight: "700",
//     letterSpacing: "0.04em",
//   },

//   statusPaid: {
//     backgroundColor: "#dcfce7",
//     color: "#15803d",
//   },

//   statusUnpaid: {
//     backgroundColor: "#fef3c7",
//     color: "#b45309",
//   },

//   editButton: {
//     width: "30px",
//     height: "30px",
//     borderRadius: "50%",
//     border: "1px solid #e5e7eb",
//     backgroundColor: "#ffffff",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "13px",
//     transition: "background-color 0.15s, border-color 0.15s",
//     padding: 0,
//   },
// };


// // client/src/pages/payment/PaymentRecordsPage.jsx

// import React, {
//   useCallback,
//   useEffect,
//   useRef,
//   useState,
// } from "react";

// import {
//   searchInvoices,
//   getQuarters,
//   updateInvoice,
// } from "../../api/paymentApi";

// import PaymentEditModal from "../../components/payment/PaymentEditModal";

// // ─────────────────────────────────────
// // CONSTANTS
// // ─────────────────────────────────────
// const VENDORS = [
//   "AIRTEL",
//   "ANONET",
//   "MICROSCAN",
//   "TATA COMMUNICATIONS",
//   "SIFY",
//   "SYMPHONY",
//   "NTT_GLOBAL",
//   "NTT",
//   "TATA_TELE",
//   "TIKONA",
//   "XTELIFY",
// ];

// const INITIAL_FILTERS = {
//   invoice_number: "",
//   vendor: "",
//   billing_quarter: "",
//   payment_status: "",
// };

// // ─────────────────────────────────────
// // HELPER — check if any filter is active
// // ─────────────────────────────────────
// const hasActiveFilters = (filters) => {
//   return (
//     filters.invoice_number.trim() !== "" ||
//     filters.vendor !== "" ||
//     filters.billing_quarter !== "" ||
//     filters.payment_status !== ""
//   );
// };

// // ─────────────────────────────────────
// // COMPONENT
// // ─────────────────────────────────────
// export default function PaymentRecordsPage() {

//   // ─────────────────────────────────────
//   // STATE
//   // ─────────────────────────────────────
//   const [filters, setFilters] = useState(INITIAL_FILTERS);

//   const [invoices, setInvoices] = useState([]);

//   const [quarters, setQuarters] = useState([]);

//   const [loading, setLoading] = useState(false);

//   const [hasSearched, setHasSearched] = useState(false);

//   const [selectedInvoice, setSelectedInvoice] = useState(null);

//   const [showEditModal, setShowEditModal] = useState(false);

//   const [saveLoading, setSaveLoading] = useState(false);

//   const debounceRef = useRef(null);

//   // ─────────────────────────────────────
//   // LOAD QUARTERS ON MOUNT
//   // ─────────────────────────────────────
//   useEffect(() => {

//     const loadQuarters = async () => {

//       try {

//         const data = await getQuarters();

//         setQuarters(data.quarters || []);

//       } catch (error) {

//         console.error("Failed to load quarters:", error);
//       }
//     };

//     loadQuarters();

//   }, []);

//   // ─────────────────────────────────────
//   // FETCH INVOICES
//   // ─────────────────────────────────────
//   const fetchInvoices = useCallback(async (currentFilters) => {

//     try {

//       setLoading(true);

//       setHasSearched(true);

//       const data = await searchInvoices(currentFilters);

//       setInvoices(data.invoices || []);

//     } catch (error) {

//       console.error("Search failed:", error);

//     } finally {

//       setLoading(false);
//     }

//   }, []);

//   // ─────────────────────────────────────
//   // DEBOUNCED SEARCH
//   // Only fires when filters are active
//   // ─────────────────────────────────────
//   useEffect(() => {

//     if (debounceRef.current) {
//       clearTimeout(debounceRef.current);
//     }

//     // ─────────────────────────────────────
//     // NO ACTIVE FILTERS — reset to empty state
//     // ─────────────────────────────────────
//     if (!hasActiveFilters(filters)) {
//       setInvoices([]);
//       setHasSearched(false);
//       return;
//     }

//     // ─────────────────────────────────────
//     // ACTIVE FILTERS — debounce the search
//     // ─────────────────────────────────────
//     debounceRef.current = setTimeout(() => {
//       fetchInvoices(filters);
//     }, 300);

//     return () => {
//       if (debounceRef.current) {
//         clearTimeout(debounceRef.current);
//       }
//     };

//   }, [filters, fetchInvoices]);

//   // ─────────────────────────────────────
//   // FILTER CHANGE
//   // ─────────────────────────────────────
//   const handleFilterChange = (key, value) => {

//     setFilters((prev) => ({
//       ...prev,
//       [key]: value,
//     }));
//   };

//   // ─────────────────────────────────────
//   // OPEN EDIT MODAL
//   // ─────────────────────────────────────
//   const handleEdit = (invoice) => {

//     setSelectedInvoice(invoice);

//     setShowEditModal(true);
//   };

//   // ─────────────────────────────────────
//   // CLOSE MODAL
//   // ─────────────────────────────────────
//   const handleCloseModal = () => {

//     setShowEditModal(false);

//     setSelectedInvoice(null);
//   };

//   // ─────────────────────────────────────
//   // SAVE INVOICE
//   // ─────────────────────────────────────
//   const handleSaveInvoice = async (updatedData) => {

//     try {

//       setSaveLoading(true);

//       await updateInvoice(selectedInvoice._id, updatedData);

//       await fetchInvoices(filters);

//       handleCloseModal();

//     } catch (error) {

//       console.error("Update Error:", error);

//       alert("Failed to update invoice");

//     } finally {

//       setSaveLoading(false);
//     }
//   };

//   // ─────────────────────────────────────
//   // RENDER TABLE BODY
//   // ─────────────────────────────────────
//   const renderTableBody = () => {

//     // ─────────────────────────────────────
//     // INITIAL STATE — no filters selected yet
//     // ─────────────────────────────────────
//     if (!hasSearched && !loading) {
//       return (
//         <tr>
//           <td colSpan={8} style={styles.promptCell}>
//             <span style={styles.promptIcon}>🔍</span>
//             <span style={styles.promptText}>
//               Start searching by Invoice Number, Vendor, Quarter or Payment Status
//             </span>
//           </td>
//         </tr>
//       );
//     }

//     // ─────────────────────────────────────
//     // LOADING STATE
//     // ─────────────────────────────────────
//     if (loading) {
//       return (
//         <tr>
//           <td colSpan={8} style={styles.promptCell}>
//             <span style={styles.loadingDot} />
//             <span style={styles.promptText}>Searching records...</span>
//           </td>
//         </tr>
//       );
//     }

//     // ─────────────────────────────────────
//     // EMPTY RESULTS — search ran but no matches
//     // ─────────────────────────────────────
//     if (hasSearched && invoices.length === 0) {
//       return (
//         <tr>
//           <td colSpan={8} style={styles.promptCell}>
//             <span style={styles.promptIcon}>📭</span>
//             <span style={styles.promptText}>
//               No records found. Try adjusting your filters.
//             </span>
//           </td>
//         </tr>
//       );
//     }

//     // ─────────────────────────────────────
//     // RESULTS
//     // ─────────────────────────────────────
//     return invoices.map((invoice, index) => (

//       <tr
//         key={invoice._id}
//         style={{
//           ...styles.tr,
//           backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9fafb",
//         }}
//       >

//         <td style={styles.td}>
//           <span style={styles.invoiceNumber}>
//             {invoice.invoice_number || "—"}
//           </span>
//         </td>

//         <td style={styles.td}>
//           <span style={styles.vendorBadge}>
//             {invoice.vendor || "—"}
//           </span>
//         </td>

//         <td style={styles.td}>
//           {invoice.service_period || "—"}
//         </td>

//         <td style={styles.td}>
//           <span style={styles.quarterBadge}>
//             {invoice.billing_quarter || "—"}
//           </span>
//         </td>

//         <td style={styles.td}>
//           <span
//             style={{
//               ...styles.statusBadge,
//               ...(invoice.payment_status === "PAID"
//                 ? styles.statusPaid
//                 : styles.statusUnpaid),
//             }}
//           >
//             {invoice.payment_status || "—"}
//           </span>
//         </td>

//         <td style={styles.td}>
//           {invoice.payment_date
//             ? new Date(invoice.payment_date).toLocaleDateString("en-IN")
//             : "—"}
//         </td>

//         <td style={styles.td}>
//           {invoice.payment_reference_number || "—"}
//         </td>

//         <td style={styles.td}>
//           <button
//             onClick={() => handleEdit(invoice)}
//             style={styles.editButton}
//             title="Edit Invoice"
//           >
//             ✏️
//           </button>
//         </td>

//       </tr>
//     ));
//   };

//   // ─────────────────────────────────────
//   // RENDER
//   // ─────────────────────────────────────
//   return (

//     <div className="page-wrap">

//       {/* HEADER */}

//       <header className="topbar">

//         <div className="brand">

//           <span className="logo">🗂️</span>

//           <div>

//             <div className="title">Payment Records</div>

//             <div className="subtitle">Search and manage invoice records</div>

//           </div>

//         </div>

//       </header>

//       {/* MAIN */}

//       <main
//         style={{
//           paddingTop: "80px",
//           paddingBottom: "60px",
//           paddingLeft: "32px",
//           paddingRight: "32px",
//           maxWidth: "1400px",
//           margin: "0 auto",
//         }}
//       >

//         {/* FILTER BAR */}

//         <div style={styles.filterBar}>

//           {/* INVOICE NUMBER */}

//           <div style={styles.filterItem}>
//             <label style={styles.filterLabel}>Invoice Number</label>
//             <input
//               type="text"
//               placeholder="Search invoice..."
//               value={filters.invoice_number}
//               onChange={(e) =>
//                 handleFilterChange("invoice_number", e.target.value)
//               }
//               style={styles.filterInput}
//             />
//           </div>

//           {/* VENDOR */}

//           <div style={styles.filterItem}>
//             <label style={styles.filterLabel}>Vendor</label>
//             <select
//               value={filters.vendor}
//               onChange={(e) =>
//                 handleFilterChange("vendor", e.target.value)
//               }
//               style={styles.filterSelect}
//             >
//               <option value="">All Vendors</option>
//               {VENDORS.map((v) => (
//                 <option key={v} value={v}>
//                   {v}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* QUARTER */}

//           <div style={styles.filterItem}>
//             <label style={styles.filterLabel}>Quarter</label>
//             <select
//               value={filters.billing_quarter}
//               onChange={(e) =>
//                 handleFilterChange("billing_quarter", e.target.value)
//               }
//               style={styles.filterSelect}
//             >
//               <option value="">All Quarters</option>
//               {quarters.map((q) => (
//                 <option key={q} value={q}>
//                   {q}
//                 </option>
//               ))}
//             </select>
//           </div>

//           {/* STATUS */}

//           <div style={styles.filterItem}>
//             <label style={styles.filterLabel}>Payment Status</label>
//             <select
//               value={filters.payment_status}
//               onChange={(e) =>
//                 handleFilterChange("payment_status", e.target.value)
//               }
//               style={styles.filterSelect}
//             >
//               <option value="">All</option>
//               <option value="PAID">PAID</option>
//               <option value="UNPAID">UNPAID</option>
//             </select>
//           </div>

//         </div>

//         {/* RESULTS META */}

//         <div style={styles.resultsMeta}>

//           {loading ? (

//             <span style={styles.loadingText}>Searching...</span>

//           ) : hasSearched ? (

//             <span style={styles.resultsCount}>
//               {invoices.length} record{invoices.length !== 1 ? "s" : ""} found
//             </span>

//           ) : (

//             <span style={styles.resultsCount}>&nbsp;</span>
//           )}

//         </div>

//         {/* TABLE WRAPPER */}

//         <div style={styles.tableWrapper}>

//           <table style={styles.table}>

//             {/* THEAD — always visible */}

//             <thead>
//               <tr>
//                 {[
//                   "Invoice Number",
//                   "Vendor",
//                   "Service Period",
//                   "Billing Quarter",
//                   "Payment Status",
//                   "Payment Date",
//                   "Reference Number",
//                   "Actions",
//                 ].map((col) => (
//                   <th key={col} style={styles.th}>
//                     {col}
//                   </th>
//                 ))}
//               </tr>
//             </thead>

//             {/* TBODY */}

//             <tbody>
//               {renderTableBody()}
//             </tbody>

//           </table>

//         </div>

//       </main>

//       {/* MODAL */}

//       {showEditModal && (

//         <PaymentEditModal
//           invoice={selectedInvoice}
//           onClose={handleCloseModal}
//           onSave={handleSaveInvoice}
//           loading={saveLoading}
//         />
//       )}

//     </div>
//   );
// }

// // ─────────────────────────────────────
// // STYLES
// // ─────────────────────────────────────
// const styles = {

//   filterBar: {
//     display: "flex",
//     flexWrap: "wrap",
//     gap: "16px",
//     alignItems: "flex-end",
//     padding: "20px 24px",
//     backgroundColor: "#ffffff",
//     border: "1px solid #e5e7eb",
//     borderRadius: "10px",
//     marginBottom: "16px",
//   },

//   filterItem: {
//     display: "flex",
//     flexDirection: "column",
//     gap: "6px",
//     minWidth: "180px",
//     flex: "1",
//   },

//   filterLabel: {
//     fontSize: "11px",
//     fontWeight: "600",
//     color: "#6b7280",
//     textTransform: "uppercase",
//     letterSpacing: "0.05em",
//   },

//   filterInput: {
//     height: "36px",
//     padding: "0 12px",
//     fontSize: "13px",
//     color: "#111827",
//     backgroundColor: "#f9fafb",
//     border: "1px solid #e5e7eb",
//     borderRadius: "6px",
//     outline: "none",
//     transition: "border-color 0.15s",
//   },

//   filterSelect: {
//     height: "36px",
//     padding: "0 12px",
//     fontSize: "13px",
//     color: "#111827",
//     backgroundColor: "#f9fafb",
//     border: "1px solid #e5e7eb",
//     borderRadius: "6px",
//     outline: "none",
//     cursor: "pointer",
//   },

//   resultsMeta: {
//     display: "flex",
//     alignItems: "center",
//     marginBottom: "10px",
//     paddingLeft: "2px",
//     minHeight: "20px",
//   },

//   resultsCount: {
//     fontSize: "13px",
//     color: "#6b7280",
//     fontWeight: "500",
//   },

//   loadingText: {
//     fontSize: "13px",
//     color: "#9ca3af",
//     fontStyle: "italic",
//   },

//   tableWrapper: {
//     width: "100%",
//     overflowX: "auto",
//     overflowY: "auto",
//     maxHeight: "calc(100vh - 280px)",
//     border: "1px solid #e5e7eb",
//     borderRadius: "10px",
//     backgroundColor: "#ffffff",
//   },

//   table: {
//     width: "100%",
//     borderCollapse: "collapse",
//     fontSize: "13px",
//     tableLayout: "auto",
//   },

//   th: {
//     position: "sticky",
//     top: 0,
//     backgroundColor: "#f3f4f6",
//     color: "#374151",
//     fontWeight: "600",
//     fontSize: "11px",
//     textTransform: "uppercase",
//     letterSpacing: "0.05em",
//     padding: "11px 16px",
//     textAlign: "left",
//     borderBottom: "1px solid #e5e7eb",
//     whiteSpace: "nowrap",
//     zIndex: 1,
//   },

//   tr: {
//     transition: "background-color 0.1s",
//   },

//   td: {
//     padding: "11px 16px",
//     color: "#374151",
//     borderBottom: "1px solid #f3f4f6",
//     whiteSpace: "nowrap",
//     verticalAlign: "middle",
//   },

//   promptCell: {
//     padding: "60px 16px",
//     textAlign: "center",
//     verticalAlign: "middle",
//   },

//   promptIcon: {
//     display: "block",
//     fontSize: "24px",
//     marginBottom: "10px",
//   },

//   promptText: {
//     display: "block",
//     fontSize: "13px",
//     color: "#9ca3af",
//     fontWeight: "500",
//   },

//   loadingDot: {
//     display: "block",
//     width: "20px",
//     height: "20px",
//     borderRadius: "50%",
//     border: "2px solid #e5e7eb",
//     borderTopColor: "#6b7280",
//     animation: "spin 0.6s linear infinite",
//     margin: "0 auto 10px auto",
//   },

//   invoiceNumber: {
//     fontFamily: "monospace",
//     fontSize: "12px",
//     color: "#1d4ed8",
//     fontWeight: "600",
//   },

//   vendorBadge: {
//     display: "inline-block",
//     padding: "2px 8px",
//     backgroundColor: "#eff6ff",
//     color: "#1d4ed8",
//     borderRadius: "4px",
//     fontSize: "11px",
//     fontWeight: "600",
//   },

//   quarterBadge: {
//     display: "inline-block",
//     padding: "2px 8px",
//     backgroundColor: "#f5f3ff",
//     color: "#7c3aed",
//     borderRadius: "4px",
//     fontSize: "11px",
//     fontWeight: "600",
//   },

//   statusBadge: {
//     display: "inline-block",
//     padding: "2px 10px",
//     borderRadius: "20px",
//     fontSize: "11px",
//     fontWeight: "700",
//     letterSpacing: "0.04em",
//   },

//   statusPaid: {
//     backgroundColor: "#dcfce7",
//     color: "#15803d",
//   },

//   statusUnpaid: {
//     backgroundColor: "#fef3c7",
//     color: "#b45309",
//   },

//   editButton: {
//     width: "30px",
//     height: "30px",
//     borderRadius: "50%",
//     border: "1px solid #e5e7eb",
//     backgroundColor: "#ffffff",
//     cursor: "pointer",
//     display: "flex",
//     alignItems: "center",
//     justifyContent: "center",
//     fontSize: "13px",
//     transition: "background-color 0.15s, border-color 0.15s",
//     padding: 0,
//   },
// };



// client/src/pages/payment/PaymentRecordsPage.jsx

import React, {
  useCallback,
  useEffect,
  useRef,
  useState,
} from "react";

import {
  searchInvoices,
  getQuarters,
  updateInvoice,
} from "../../api/paymentApi";

import PaymentEditModal from "../../components/payment/PaymentEditModal";

// ─────────────────────────────────────
// CONSTANTS
// ─────────────────────────────────────
const VENDORS = [
  "AIRTEL",
  "ANONET",
  "MICROSCAN",
  "TATA COMMUNICATIONS",
  "SIFY",
  "SYMPHONY",
  "NTT_GLOBAL",
  "NTT",
  "TATA_TELE",
  "TIKONA",
  "XTELIFY",
];

const INITIAL_FILTERS = {
  invoice_number: "",
  vendor: "",
  billing_quarter: "",
  payment_status: "",
};

// ─────────────────────────────────────
// COMPONENT
// ─────────────────────────────────────
export default function PaymentRecordsPage() {

  // ─────────────────────────────────────
  // STATE
  // ─────────────────────────────────────
  const [filters, setFilters] = useState(INITIAL_FILTERS);

  const [invoices, setInvoices] = useState([]);

  const [quarters, setQuarters] = useState([]);

  const [loading, setLoading] = useState(false);

  const [hasSearched, setHasSearched] = useState(false);

  const [selectedInvoice, setSelectedInvoice] = useState(null);

  const [showEditModal, setShowEditModal] = useState(false);

  const [saveLoading, setSaveLoading] = useState(false);

  const debounceRef = useRef(null);

  // ─────────────────────────────────────
  // LOAD QUARTERS ON MOUNT
  // ─────────────────────────────────────
  useEffect(() => {

    const loadQuarters = async () => {

      try {

        const data = await getQuarters();

        setQuarters(data.quarters || []);

      } catch (error) {

        console.error("Failed to load quarters:", error);
      }
    };

    loadQuarters();

  }, []);

  // ─────────────────────────────────────
  // FETCH INVOICES
  // ─────────────────────────────────────
  const fetchInvoices = useCallback(async (currentFilters) => {

    try {

      setLoading(true);

      setHasSearched(true);

      const data = await searchInvoices(currentFilters);

      setInvoices(data.invoices || []);

    } catch (error) {

      console.error("Search failed:", error);

    } finally {

      setLoading(false);
    }

  }, []);

  // ─────────────────────────────────────
  // DEBOUNCED SEARCH
  // Fires on mount and whenever filters change
  // ─────────────────────────────────────
  useEffect(() => {

    if (debounceRef.current) {
      clearTimeout(debounceRef.current);
    }

    debounceRef.current = setTimeout(() => {
      fetchInvoices(filters);
    }, 300);

    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current);
      }
    };

  }, [filters, fetchInvoices]);

  // ─────────────────────────────────────
  // FILTER CHANGE
  // ─────────────────────────────────────
  const handleFilterChange = (key, value) => {

    setFilters((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  // ─────────────────────────────────────
  // OPEN EDIT MODAL
  // ─────────────────────────────────────
  const handleEdit = (invoice) => {

    setSelectedInvoice(invoice);

    setShowEditModal(true);
  };

  // ─────────────────────────────────────
  // CLOSE MODAL
  // ─────────────────────────────────────
  const handleCloseModal = () => {

    setShowEditModal(false);

    setSelectedInvoice(null);
  };

  // ─────────────────────────────────────
  // SAVE INVOICE
  // ─────────────────────────────────────
  const handleSaveInvoice = async (updatedData) => {

    try {

      setSaveLoading(true);

      await updateInvoice(selectedInvoice._id, updatedData);

      await fetchInvoices(filters);

      handleCloseModal();

    } catch (error) {

      console.error("Update Error:", error);

      alert("Failed to update invoice");

    } finally {

      setSaveLoading(false);
    }
  };

  // ─────────────────────────────────────
  // RENDER TABLE BODY
  // ─────────────────────────────────────
  const renderTableBody = () => {

    // ─────────────────────────────────────
    // INITIAL STATE — no filters selected yet
    // ─────────────────────────────────────
    if (!hasSearched && !loading) {
      return (
        <tr>
          <td colSpan={8} style={styles.promptCell}>
            <span style={styles.promptIcon}>🔍</span>
            <span style={styles.promptText}>
              Start searching by Invoice Number, Vendor, Quarter or Payment Status
            </span>
          </td>
        </tr>
      );
    }

    // ─────────────────────────────────────
    // LOADING STATE
    // ─────────────────────────────────────
    if (loading) {
      return (
        <tr>
          <td colSpan={8} style={styles.promptCell}>
            <span style={styles.loadingDot} />
            <span style={styles.promptText}>Searching records...</span>
          </td>
        </tr>
      );
    }

    // ─────────────────────────────────────
    // EMPTY RESULTS — search ran but no matches
    // ─────────────────────────────────────
    if (hasSearched && invoices.length === 0) {
      return (
        <tr>
          <td colSpan={8} style={styles.promptCell}>
            <span style={styles.promptIcon}>📭</span>
            <span style={styles.promptText}>
              No records found. Try adjusting your filters.
            </span>
          </td>
        </tr>
      );
    }

    // ─────────────────────────────────────
    // RESULTS
    // ─────────────────────────────────────
    return invoices.map((invoice, index) => (

      <tr
        key={invoice._id}
        style={{
          ...styles.tr,
          backgroundColor: index % 2 === 0 ? "#ffffff" : "#f9fafb",
        }}
      >

        <td style={styles.td}>
          <span style={styles.invoiceNumber}>
            {invoice.invoice_number || "—"}
          </span>
        </td>

        <td style={styles.td}>
          <span style={styles.vendorBadge}>
            {invoice.vendor || "—"}
          </span>
        </td>

        <td style={styles.td}>
          {invoice.service_period || "—"}
        </td>

        <td style={styles.td}>
          <span style={styles.quarterBadge}>
            {invoice.billing_quarter || "—"}
          </span>
        </td>

        <td style={styles.td}>
          <span
            style={{
              ...styles.statusBadge,
              ...(invoice.payment_status === "PAID"
                ? styles.statusPaid
                : styles.statusUnpaid),
            }}
          >
            {invoice.payment_status || "—"}
          </span>
        </td>

        <td style={styles.td}>
          {invoice.payment_date
            ? new Date(invoice.payment_date).toLocaleDateString("en-IN")
            : "—"}
        </td>

        <td style={styles.td}>
          {invoice.payment_reference_number || "—"}
        </td>

        <td style={styles.td}>
          <button
            onClick={() => handleEdit(invoice)}
            style={styles.editButton}
            title="Edit Invoice"
          >
            ✏️
          </button>
        </td>

      </tr>
    ));
  };

  // ─────────────────────────────────────
  // RENDER
  // ─────────────────────────────────────
  return (

    <div className="page-wrap">

      {/* HEADER */}

      <header className="topbar">

        <div className="brand">

          <span className="logo">🗂️</span>

          <div>

            <div className="title">Payment Records</div>

            <div className="subtitle">Search and manage invoice records</div>

          </div>

        </div>

      </header>

      {/* MAIN */}

      <main
        style={{
          paddingTop: "80px",
          paddingBottom: "60px",
          paddingLeft: "32px",
          paddingRight: "32px",
          maxWidth: "1400px",
          margin: "0 auto",
        }}
      >

        {/* FILTER BAR */}

        <div style={styles.filterBar}>

          {/* INVOICE NUMBER */}

          <div style={styles.filterItem}>
            <label style={styles.filterLabel}>Invoice Number</label>
            <input
              type="text"
              placeholder="Search invoice..."
              value={filters.invoice_number}
              onChange={(e) =>
                handleFilterChange("invoice_number", e.target.value)
              }
              style={styles.filterInput}
            />
          </div>

          {/* VENDOR */}

          <div style={styles.filterItem}>
            <label style={styles.filterLabel}>Vendor</label>
            <select
              value={filters.vendor}
              onChange={(e) =>
                handleFilterChange("vendor", e.target.value)
              }
              style={styles.filterSelect}
            >
              <option value="">All Vendors</option>
              {VENDORS.map((v) => (
                <option key={v} value={v}>
                  {v}
                </option>
              ))}
            </select>
          </div>

          {/* QUARTER */}

          <div style={styles.filterItem}>
            <label style={styles.filterLabel}>Quarter</label>
            <select
              value={filters.billing_quarter}
              onChange={(e) =>
                handleFilterChange("billing_quarter", e.target.value)
              }
              style={styles.filterSelect}
            >
              <option value="">All Quarters</option>
              {quarters.map((q) => (
                <option key={q} value={q}>
                  {q}
                </option>
              ))}
            </select>
          </div>

          {/* STATUS */}

          <div style={styles.filterItem}>
            <label style={styles.filterLabel}>Payment Status</label>
            <select
              value={filters.payment_status}
              onChange={(e) =>
                handleFilterChange("payment_status", e.target.value)
              }
              style={styles.filterSelect}
            >
              <option value="">All</option>
              <option value="PAID">PAID</option>
              <option value="UNPAID">UNPAID</option>
            </select>
          </div>

        </div>

        {/* RESULTS META */}

        <div style={styles.resultsMeta}>

          {loading ? (

            <span style={styles.loadingText}>Searching...</span>

          ) : hasSearched ? (

            <span style={styles.resultsCount}>
              {invoices.length} record{invoices.length !== 1 ? "s" : ""} found
            </span>

          ) : (

            <span style={styles.resultsCount}>&nbsp;</span>
          )}

        </div>

        {/* TABLE WRAPPER */}

        <div style={styles.tableWrapper}>

          <table style={styles.table}>

            {/* THEAD — always visible */}

            <thead>
              <tr>
                {[
                  "Invoice Number",
                  "Vendor",
                  "Service Period",
                  "Billing Quarter",
                  "Payment Status",
                  "Payment Date",
                  "Reference Number",
                  "Actions",
                ].map((col) => (
                  <th key={col} style={styles.th}>
                    {col}
                  </th>
                ))}
              </tr>
            </thead>

            {/* TBODY */}

            <tbody>
              {renderTableBody()}
            </tbody>

          </table>

        </div>

      </main>

      {/* MODAL */}

      {showEditModal && (

        <PaymentEditModal
          invoice={selectedInvoice}
          onClose={handleCloseModal}
          onSave={handleSaveInvoice}
          loading={saveLoading}
        />
      )}

    </div>
  );
}

// ─────────────────────────────────────
// STYLES
// ─────────────────────────────────────
const styles = {

  filterBar: {
    display: "flex",
    flexWrap: "wrap",
    gap: "16px",
    alignItems: "flex-end",
    padding: "20px 24px",
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    marginBottom: "16px",
  },

  filterItem: {
    display: "flex",
    flexDirection: "column",
    gap: "6px",
    minWidth: "180px",
    flex: "1",
  },

  filterLabel: {
    fontSize: "11px",
    fontWeight: "600",
    color: "#6b7280",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
  },

  filterInput: {
    height: "36px",
    padding: "0 12px",
    fontSize: "13px",
    color: "#111827",
    backgroundColor: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "6px",
    outline: "none",
    transition: "border-color 0.15s",
  },

  filterSelect: {
    height: "36px",
    padding: "0 12px",
    fontSize: "13px",
    color: "#111827",
    backgroundColor: "#f9fafb",
    border: "1px solid #e5e7eb",
    borderRadius: "6px",
    outline: "none",
    cursor: "pointer",
  },

  resultsMeta: {
    display: "flex",
    alignItems: "center",
    marginBottom: "10px",
    paddingLeft: "2px",
    minHeight: "20px",
  },

  resultsCount: {
    fontSize: "13px",
    color: "#6b7280",
    fontWeight: "500",
  },

  loadingText: {
    fontSize: "13px",
    color: "#9ca3af",
    fontStyle: "italic",
  },

  tableWrapper: {
    width: "100%",
    overflowX: "auto",
    overflowY: "auto",
    maxHeight: "calc(100vh - 280px)",
    border: "1px solid #e5e7eb",
    borderRadius: "10px",
    backgroundColor: "#ffffff",
  },

  table: {
    width: "100%",
    borderCollapse: "collapse",
    fontSize: "13px",
    tableLayout: "auto",
  },

  th: {
    position: "sticky",
    top: 0,
    backgroundColor: "#f3f4f6",
    color: "#374151",
    fontWeight: "600",
    fontSize: "11px",
    textTransform: "uppercase",
    letterSpacing: "0.05em",
    padding: "11px 16px",
    textAlign: "left",
    borderBottom: "1px solid #e5e7eb",
    whiteSpace: "nowrap",
    zIndex: 1,
  },

  tr: {
    transition: "background-color 0.1s",
  },

  td: {
    padding: "11px 16px",
    color: "#374151",
    borderBottom: "1px solid #f3f4f6",
    whiteSpace: "nowrap",
    verticalAlign: "middle",
  },

  promptCell: {
    padding: "60px 16px",
    textAlign: "center",
    verticalAlign: "middle",
  },

  promptIcon: {
    display: "block",
    fontSize: "24px",
    marginBottom: "10px",
  },

  promptText: {
    display: "block",
    fontSize: "13px",
    color: "#9ca3af",
    fontWeight: "500",
  },

  loadingDot: {
    display: "block",
    width: "20px",
    height: "20px",
    borderRadius: "50%",
    border: "2px solid #e5e7eb",
    borderTopColor: "#6b7280",
    animation: "spin 0.6s linear infinite",
    margin: "0 auto 10px auto",
  },

  invoiceNumber: {
    fontFamily: "monospace",
    fontSize: "12px",
    color: "#1d4ed8",
    fontWeight: "600",
  },

  vendorBadge: {
    display: "inline-block",
    padding: "2px 8px",
    backgroundColor: "#eff6ff",
    color: "#1d4ed8",
    borderRadius: "4px",
    fontSize: "11px",
    fontWeight: "600",
  },

  quarterBadge: {
    display: "inline-block",
    padding: "2px 8px",
    backgroundColor: "#f5f3ff",
    color: "#7c3aed",
    borderRadius: "4px",
    fontSize: "11px",
    fontWeight: "600",
  },

  statusBadge: {
    display: "inline-block",
    padding: "2px 10px",
    borderRadius: "20px",
    fontSize: "11px",
    fontWeight: "700",
    letterSpacing: "0.04em",
  },

  statusPaid: {
    backgroundColor: "#dcfce7",
    color: "#15803d",
  },

  statusUnpaid: {
    backgroundColor: "#fef3c7",
    color: "#b45309",
  },

  editButton: {
    width: "30px",
    height: "30px",
    borderRadius: "50%",
    border: "1px solid #e5e7eb",
    backgroundColor: "#ffffff",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "13px",
    transition: "background-color 0.15s, border-color 0.15s",
    padding: 0,
  },
};